import { useLocation } from "wouter";
import ResponsiveNav from "./Nav/ResponsiveNav";
import { SERVICES_LINKS } from "routes/routes";
import apiService from 'Services/apiService';

export const Header = () => {
  const [path] = useLocation();
  const [, setLocation] = useLocation();

  const storedUserType = localStorage.getItem('user') || '{}';
  const userType = JSON.parse(storedUserType)?._idTipoUsuario || 0;
  const filteredLinks = SERVICES_LINKS.find((links) => links.userType === userType)?.links;

  const logout = () => {
    apiService({
      name: 'logout',
      onSuccess: (data) => {
        setLocation('/login');
      },
      onError: (error) => {
        console.error('Error:', error);
      },
    });
  };
  
  return (
    <>
      {!['/login', '/recovery'].includes(path) && (
        <ResponsiveNav 
          SERVICES_LINKS={filteredLinks}
          path={path}
          logout={logout}
        />
      )}
    </>
  );
};
